import { useEffect, useMemo, useState } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import {
  type ISourceOptions,
  MoveDirection,
  OutMode,
} from "@tsparticles/engine";
import { loadSlim } from "@tsparticles/slim";

export default function Background() {
  const [init, setInit] = useState(false);
  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  const options: ISourceOptions = useMemo(
    () => ({
      fpsLimit: 144,
      background: {
        image:
          "linear-gradient(25deg, black 0%, black 15%, #121017 50%, black 85%, black 100%)",
      },
      interactivity: {
        events: {
          onClick: {
            enable: true,
            mode: "push",
          },
          onHover: {
            enable: true,
            mode: ["repulse", "bubble"],
          },
        },
        modes: {
          push: {
            quantity: 1,
            duration: 1000,
          },
          repulse: {
            distance: 100,
            duration: 1000,
          },
          bubble: {
            distance: 250,
            duration: 0.5,
            opacity: 0.4,
            size: 24,
            speed: 5,
          },
        },
      },
      particles: {
        color: {
          value: ["#1b1823", "#1b1823", "#6b617d"],
        },
        move: {
          direction: MoveDirection.none,
          enable: true,
          outModes: {
            default: OutMode.out,
          },
          random: false,
          speed: 1,
          straight: false,
        },
        number: {
          density: {
            enable: true,
          },
          value: 20,
        },
        opacity: {
          value: 0.25,
        },
        shape: {
          type: "circle",
        },
        size: {
          value: { min: 1, max: 12 },
        },
      },
      detectRetina: true,
      fullScreen: { enable: false },
      style: {
        width: `100vw`,
        height: `100vh`,
      },
    }),
    [],
  );

  if (init) {
    return (
      <Particles
        id="tsparticles"
        options={options}
        className="fixed right-0 top-0 -z-10"
      />
    );
  }

  return <></>;
}
